<div class="page has-title">
  <h1>{{ title }}</h1>

  <div class="row g-0 g-3">
    <div class="col-md-3">
      <astrobin-migration-nav></astrobin-migration-nav>
      <astrobin-equipment-item-type-nav
        [showBrands]="false"
        [showContributors]="false"
        [showSubNavigation]="false"
        routingBasePath="/equipment/migration-explorer"
      ></astrobin-equipment-item-type-nav>
    </div>

    <div class="col-md-7">
      <astrobin-equipment-explorer
        [activeEditProposalId]="activeEditProposalId"
        [activeId]="activeId"
        [activeType]="activeType"
        [showForum]="false"
        [showImagesUsing]="false"
        [showMostOftenUsedWith]="false"
        routingBasePath="/equipment/migration-explorer"
      ></astrobin-equipment-explorer>
    </div>
    <!-- main col -->

    <div class="col-md-2">
      <astrobin-migration-guidelines></astrobin-migration-guidelines>
    </div>
    <!-- guidelines col -->
  </div>
  <!-- main row -->
</div>
<!-- page -->
